<template>
  <b-table hover striped show-empty responsive :items="visits" :fields="fields" no-border-collapse outlined
    class="table-container" head-variant="light">
    <template #cell(id)="data">
      <span class="typo-color-blue cursor-pointer">
        <a
          :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.member_id}/visits/${data.item.id}`)"
          target="_blank"
        >
          {{ data.item.id }}
        </a>
      </span>
    </template>
    <template #cell(member_id)="data">
      <span class="typo-color-blue cursor-pointer">
        <a
          :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.member_id}`)"
          target="_blank"
        >
          {{ data.item.member_id }}
        </a>
      </span>
    </template>
    <template #cell(program)="data">
      <router-link :to="{ name: programLegacyURL(data.item.program_type, true), params: { id: data.item.program_id }}">
        <span class="typo-color-blue cursor-pointer">
          {{ data.item.program }}
        </span>
      </router-link>
    </template>
    <template #cell(arrival_and_departure)="data">
      <span class="text-nowrap" v-if="data.item.estimated_arrival_date && data.item.estimated_departure_date">
        {{moment(data.item.estimated_arrival_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY')}}
        -
        {{moment(data.item.estimated_departure_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY')}}
      </span>
    </template>
    <template #cell(sign_in_date)="data">
      <span class="text-nowrap" v-if="data.item.sign_in_date">
        {{moment(data.item.sign_in_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY')}}
      </span>
      <a
        v-if="data.item.can_signin && canEditCms"
        :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.member_id}/visits/${data.item.id}/signins${data.item.signin_completed ? '/begin' : ''}`)"
        target="_blank"
        >
        <i class="fa fa-edit custom-fa-edit-color" v-b-tooltip.hover title="Edit Sign In"></i>
      </a>
    </template>
    <template #cell(sign_out_date)="data">
      <span class="text-nowrap" v-if="data.item.sign_out_date">
        {{moment(data.item.sign_out_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY')}}
      </span>
    </template>
    <template #cell(exit_survey_date)="data">
      <span v-if="data.item.exit_survey_date" class="text-nowrap">{{moment(data.item.exit_survey_date, 'YYYY-MM-DD HH:mm:ss').format('MMM Do, YYYY')}}</span>
      <span v-else>-</span>
    </template>
    <template #cell(action)="data">
      <a
        :href="fetchLegacyUrl(`/${programLegacyURL(data.item.program_type, false)}/${data.item.program_id}/members/${data.item.member_id}/visits/${data.item.id}/edit`)"
        target="_blank"
        v-if="canEditCms"
        >
        <i class="fa fa-edit custom-fa-edit-color" v-b-tooltip.hover title="Edit Visit"></i>
      </a>
    </template>
  </b-table>
</template>

<script>
import mixin from "@/utils/mixin.js"
import { mapGetters } from "vuex"

export default {
	name: "PersonProgramVisits",
	mixins: [mixin],
	computed: {
		...mapGetters(["canEditCms"]),
	},
	props: ["visits"],
	data() {
		return {
			fields: [
				{
					key: "id",
					label: "Visit ID",
				},
				{
					key: "member_id",
					label: "Member ID",
				},
				"program",
				{
					key: "arrival_and_departure",
					label: "Estimated Arrival & Departure",
				},
				"type",
				{
					key: "sign_in_date",
					label: "Sign-In",
				},
				{
					key: "sign_out_date",
					label: "Sign-Out",
				},
				{
					key: "exit_survey_date",
					label: "Exit Survey Date",
				},
				{
					key: "action",
					label: "",
				},
			],
		}
	},
}
</script>
